// FloatingButton.tsx
import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { WA_NUMBER } from '../constant/detail';

const FloatingButton = () => {
  return (
    <a
      href={`https://wa.me/${WA_NUMBER}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 bg-green-500 text-white p-4 rounded-full shadow-lg hover:bg-green-600 transition z-50"
      title="Chat via WhatsApp"
      aria-label="Hubungi Pool Shop Surya Jaya Teknik via WhatsApp"
    >
      <FaWhatsapp className="w-6 h-6" />
    </a>
  );
};

export default FloatingButton;
